"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectNotifications = exports.resetStateAction = exports.reducer = exports.pushNotificationActionOnce = exports.pushNotificationAction = exports.name = exports.closeNotificationAction = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _toolkit = require("@reduxjs/toolkit");

var REDUCER_NAME = 'package/notifications';
var initialState = {
  notifications: []
};
var slice = (0, _toolkit.createSlice)({
  name: REDUCER_NAME,
  initialState: initialState,
  reducers: {
    resetStateAction: function resetStateAction(state) {
      state['notifications'] = [];
    },
    closeNotificationAction: function closeNotificationAction(state, _ref) {
      var payload = _ref.payload;
      var index = state['notifications'].findIndex(function (item) {
        return item['uuid'] === payload;
      });
      state['notifications'] = [].concat((0, _toConsumableArray2["default"])(state['notifications'].slice(0, index)), (0, _toConsumableArray2["default"])(state['notifications'].slice(index + 1)));
    },
    pushNotificationAction: function pushNotificationAction(state, _ref2) {
      var payload = _ref2.payload;
      state['notifications'] = [].concat((0, _toConsumableArray2["default"])(state['notifications']), [payload]);
    },
    pushNotificationActionOnce: function pushNotificationActionOnce(state, _ref3) {
      var payload = _ref3.payload;
      var index = state['notifications'].findIndex(function (item) {
        return item['uuid'] === payload.uuid;
      });

      if (index === -1) {
        state['notifications'] = [].concat((0, _toConsumableArray2["default"])(state['notifications']), [payload]);
      }
    }
  }
});
var _slice$actions = slice['actions'],
    resetStateAction = _slice$actions.resetStateAction,
    pushNotificationAction = _slice$actions.pushNotificationAction,
    pushNotificationActionOnce = _slice$actions.pushNotificationActionOnce,
    closeNotificationAction = _slice$actions.closeNotificationAction;
exports.closeNotificationAction = closeNotificationAction;
exports.pushNotificationActionOnce = pushNotificationActionOnce;
exports.pushNotificationAction = pushNotificationAction;
exports.resetStateAction = resetStateAction;

var selectNotifications = function selectNotifications(state) {
  return state[REDUCER_NAME]['notifications'];
};

exports.selectNotifications = selectNotifications;
var name = slice['name'];
exports.name = name;
var reducer = slice['reducer'];
exports.reducer = reducer;